/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from '../ErrorPage/ErrorPage';

export function NetworkError() {
  const { t } = useTranslation();
  return <ErrorPage text={t('networkError.title')} />;
}
